import React from 'react';
import { Helmet } from 'react-helmet';

// Global metadata for the entire application
export const GlobalHelmet = () => (
  <Helmet>
    {/* Global Meta Tags */}
    <meta charSet="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="theme-color" content="#000000" />
    <meta name="application-name" content="MoiPay.lk" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-status-bar-style" content="default" />
    <meta name="apple-mobile-web-app-title" content="MoiPay.lk" />
    <meta name="format-detection" content="telephone=no" />
    <meta name="mobile-web-app-capable" content="yes" />
    
    {/* Favicon and Icons */}
    <link rel="icon" href="%PUBLIC_URL%/favi.ico" />
    <link rel="apple-touch-icon" href="%PUBLIC_URL%/logo192.png" />
    <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
    
    {/* Preconnect to external domains for performance */}
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
  </Helmet>
);

// Home page metadata
export const HomeHelmet = () => (
  <Helmet>
    <title>MoiPay.lk - Sri Lanka's Leading Digital Payment Solution</title>
    <meta name="description" content="MoiPay.lk is Sri Lanka's premier digital payment platform. Send money, pay bills, and manage your finances securely with our innovative mobile payment solution." />
    <meta name="keywords" content="digital payments, mobile money, Sri Lanka, MoiPay, online payments, bill payments, money transfer, fintech" />
    <meta name="author" content="MoiPay.lk" />
    <meta name="robots" content="index, follow" />
    
    {/* Open Graph / Facebook */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://moipay.lk/" />
    <meta property="og:title" content="MoiPay.lk - Sri Lanka's Leading Digital Payment Solution" />
    <meta property="og:description" content="MoiPay.lk is Sri Lanka's premier digital payment platform. Send money, pay bills, and manage your finances securely with our innovative mobile payment solution." />
    <meta property="og:image" content="https://moipay.lk/og-image.jpg" />
    <meta property="og:site_name" content="MoiPay.lk" />
    <meta property="og:locale" content="en_US" />
    
    {/* Twitter */}
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:url" content="https://moipay.lk/" />
    <meta property="twitter:title" content="MoiPay.lk - Sri Lanka's Leading Digital Payment Solution" />
    <meta property="twitter:description" content="MoiPay.lk is Sri Lanka's premier digital payment platform. Send money, pay bills, and manage your finances securely." />
    <meta property="twitter:image" content="https://moipay.lk/twitter-image.jpg" />
    
    {/* Additional Meta Tags */}
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="theme-color" content="#000000" />
    <link rel="canonical" href="https://moipay.lk/" />
  </Helmet>
);

// About page metadata
export const AboutHelmet = () => (
  <Helmet>
    <title>About Us - MoiPay.lk | Our Story & Mission</title>
    <meta name="description" content="Learn about MoiPay.lk's journey, mission, and commitment to revolutionizing digital payments in Sri Lanka. Discover our innovative approach to financial technology." />
    <meta name="keywords" content="about MoiPay, company history, mission, vision, digital payments Sri Lanka, fintech company, mobile money innovation" />
    <meta name="author" content="MoiPay.lk" />
    <meta name="robots" content="index, follow" />
    
    {/* Open Graph / Facebook */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://moipay.lk/about" />
    <meta property="og:title" content="About Us - MoiPay.lk | Our Story & Mission" />
    <meta property="og:description" content="Learn about MoiPay.lk's journey, mission, and commitment to revolutionizing digital payments in Sri Lanka." />
    <meta property="og:image" content="https://moipay.lk/about-og-image.jpg" />
    <meta property="og:site_name" content="MoiPay.lk" />
    <meta property="og:locale" content="en_US" />
    
    {/* Twitter */}
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:url" content="https://moipay.lk/about" />
    <meta property="twitter:title" content="About Us - MoiPay.lk | Our Story & Mission" />
    <meta property="twitter:description" content="Learn about MoiPay.lk's journey, mission, and commitment to revolutionizing digital payments in Sri Lanka." />
    <meta property="twitter:image" content="https://moipay.lk/about-twitter-image.jpg" />
    
    {/* Additional Meta Tags */}
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="theme-color" content="#000000" />
    <link rel="canonical" href="https://moipay.lk/about" />
  </Helmet>
);

// Team page metadata
export const TeamHelmet = () => (
  <Helmet>
    <title>Our Team - MoiPay.lk | Meet the Experts</title>
    <meta name="description" content="Meet the talented team behind MoiPay.lk. Our experts in fintech, software development, and digital payments are dedicated to revolutionizing Sri Lanka's financial landscape." />
    <meta name="keywords" content="MoiPay team, leadership, fintech experts, software developers, digital payments team, Sri Lanka fintech, company team" />
    <meta name="author" content="MoiPay.lk" />
    <meta name="robots" content="index, follow" />
    
    {/* Open Graph / Facebook */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://moipay.lk/team" />
    <meta property="og:title" content="Our Team - MoiPay.lk | Meet the Experts" />
    <meta property="og:description" content="Meet the talented team behind MoiPay.lk. Our experts in fintech, software development, and digital payments are dedicated to revolutionizing Sri Lanka's financial landscape." />
    <meta property="og:image" content="https://moipay.lk/team-og-image.jpg" />
    <meta property="og:site_name" content="MoiPay.lk" />
    <meta property="og:locale" content="en_US" />
    
    {/* Twitter */}
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:url" content="https://moipay.lk/team" />
    <meta property="twitter:title" content="Our Team - MoiPay.lk | Meet the Experts" />
    <meta property="twitter:description" content="Meet the talented team behind MoiPay.lk. Our experts in fintech, software development, and digital payments are dedicated to revolutionizing Sri Lanka's financial landscape." />
    <meta property="twitter:image" content="https://moipay.lk/team-twitter-image.jpg" />
    
    {/* Additional Meta Tags */}
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="theme-color" content="#000000" />
    <link rel="canonical" href="https://moipay.lk/team" />
  </Helmet>
);



// Blog page metadata
export const BlogHelmet = () => (
  <Helmet>
    <title>Blog - MoiPay.lk | Insights, Updates & Fintech News</title>
    <meta
      name="description"
      content="Stay updated with MoiPay.lk! Explore our latest blog posts featuring fintech insights, digital payment trends, product updates, and behind-the-scenes stories from Sri Lanka’s leading digital finance platform."
    />
    <meta
      name="keywords"
      content="MoiPay blog, fintech insights, digital payments, Sri Lanka fintech, MoiPay updates, payment technology news, fintech blog, MoiPay.lk articles"
    />
    <meta name="author" content="MoiPay.lk" />
    <meta name="robots" content="index, follow" />

    {/* Open Graph / Facebook */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://moipay.lk/blog" />
    <meta property="og:title" content="Blog - MoiPay.lk | Insights, Updates & Fintech News" />
    <meta
      property="og:description"
      content="Read MoiPay.lk's latest blog posts for fintech insights, digital payment updates, and company news."
    />
    <meta property="og:image" content="https://moipay.lk/blog-og-image.jpg" />
    <meta property="og:site_name" content="MoiPay.lk" />
    <meta property="og:locale" content="en_US" />

    {/* Twitter */}
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:url" content="https://moipay.lk/blog" />
    <meta property="twitter:title" content="Blog - MoiPay.lk | Insights, Updates & Fintech News" />
    <meta
      property="twitter:description"
      content="Stay updated with MoiPay.lk's fintech news, digital payment guides, and product updates."
    />
    <meta property="twitter:image" content="https://moipay.lk/blog-twitter-image.jpg" />

    {/* Additional Meta Tags */}
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="theme-color" content="#000000" />
    <link rel="canonical" href="https://moipay.lk/blog" />
  </Helmet>
);









// Contact page metadata
export const ContactHelmet = () => (
  <Helmet>
    <title>Contact Us - MoiPay.lk | Get in Touch</title>
    <meta name="description" content="Contact MoiPay.lk for support, partnerships, or inquiries. Our team is here to help with your digital payment needs and questions about our services." />
    <meta name="keywords" content="contact MoiPay, customer support, partnership inquiries, digital payments support, MoiPay contact, Sri Lanka fintech contact" />
    <meta name="author" content="MoiPay.lk" />
    <meta name="robots" content="index, follow" />
    
    {/* Open Graph / Facebook */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://moipay.lk/contact" />
    <meta property="og:title" content="Contact Us - MoiPay.lk | Get in Touch" />
    <meta property="og:description" content="Contact MoiPay.lk for support, partnerships, or inquiries. Our team is here to help with your digital payment needs." />
    <meta property="og:image" content="https://moipay.lk/contact-og-image.jpg" />
    <meta property="og:site_name" content="MoiPay.lk" />
    <meta property="og:locale" content="en_US" />
    
    {/* Twitter */}
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:url" content="https://moipay.lk/contact" />
    <meta property="twitter:title" content="Contact Us - MoiPay.lk | Get in Touch" />
    <meta property="twitter:description" content="Contact MoiPay.lk for support, partnerships, or inquiries. Our team is here to help with your digital payment needs." />
    <meta property="twitter:image" content="https://moipay.lk/contact-twitter-image.jpg" />
    
    {/* Additional Meta Tags */}
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="theme-color" content="#000000" />
    <link rel="canonical" href="https://moipay.lk/contact" />
  </Helmet>
);

// Terms page metadata
export const TermsHelmet = () => (
  <Helmet>
    <title>Terms & Conditions - MoiPay.lk | Legal Information</title>
    <meta name="description" content="Read MoiPay.lk's Terms & Conditions. Understand our service agreements, user obligations, and legal framework for our digital payment platform in Sri Lanka." />
    <meta name="keywords" content="MoiPay terms, conditions, legal, user agreement, digital payments terms, Sri Lanka fintech legal, service agreement" />
    <meta name="author" content="MoiPay.lk" />
    <meta name="robots" content="index, follow" />
    
    {/* Open Graph / Facebook */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://moipay.lk/terms" />
    <meta property="og:title" content="Terms & Conditions - MoiPay.lk | Legal Information" />
    <meta property="og:description" content="Read MoiPay.lk's Terms & Conditions. Understand our service agreements, user obligations, and legal framework for our digital payment platform." />
    <meta property="og:image" content="https://moipay.lk/terms-og-image.jpg" />
    <meta property="og:site_name" content="MoiPay.lk" />
    <meta property="og:locale" content="en_US" />
    
    {/* Twitter */}
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:url" content="https://moipay.lk/terms" />
    <meta property="twitter:title" content="Terms & Conditions - MoiPay.lk | Legal Information" />
    <meta property="twitter:description" content="Read MoiPay.lk's Terms & Conditions. Understand our service agreements, user obligations, and legal framework for our digital payment platform." />
    <meta property="twitter:image" content="https://moipay.lk/terms-twitter-image.jpg" />
    
    {/* Additional Meta Tags */}
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="theme-color" content="#000000" />
    <link rel="canonical" href="https://moipay.lk/terms" />
  </Helmet>
);

// Privacy page metadata
export const PrivacyHelmet = () => (
  <Helmet>
    <title>Privacy Policy - MoiPay.lk | Data Protection</title>
    <meta name="description" content="Read MoiPay.lk's Privacy Policy. Learn how we collect, use, and protect your personal data in accordance with Sri Lanka's data protection laws." />
    <meta name="keywords" content="MoiPay privacy policy, data protection, personal data, Sri Lanka data protection, fintech privacy, user data security" />
    <meta name="author" content="MoiPay.lk" />
    <meta name="robots" content="index, follow" />
    
    {/* Open Graph / Facebook */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://moipay.lk/privacy" />
    <meta property="og:title" content="Privacy Policy - MoiPay.lk | Data Protection" />
    <meta property="og:description" content="Read MoiPay.lk's Privacy Policy. Learn how we collect, use, and protect your personal data in accordance with Sri Lanka's data protection laws." />
    <meta property="og:image" content="https://moipay.lk/privacy-og-image.jpg" />
    <meta property="og:site_name" content="MoiPay.lk" />
    <meta property="og:locale" content="en_US" />
    
    {/* Twitter */}
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:url" content="https://moipay.lk/privacy" />
    <meta property="twitter:title" content="Privacy Policy - MoiPay.lk | Data Protection" />
    <meta property="twitter:description" content="Read MoiPay.lk's Privacy Policy. Learn how we collect, use, and protect your personal data in accordance with Sri Lanka's data protection laws." />
    <meta property="twitter:image" content="https://moipay.lk/privacy-twitter-image.jpg" />
    
    {/* Additional Meta Tags */}
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="theme-color" content="#000000" />
    <link rel="canonical" href="https://moipay.lk/privacy" />
  </Helmet>
); 